/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BuiltInRoleKey {
    ADMINISTRATOR = 'Administrator',
    PROJECT_READER = 'ProjectReader',
    PROJECT_EDITOR = 'ProjectEditor',
    COMMENTER = 'Commenter',
}
